module.exports = __webpack_public_path__ + "static/media/logo.9b7d1e6b.svg";